import React from 'react';
import { Lock } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

interface RoleProtectedWrapperProps {
    children: React.ReactNode;
}

export function RoleProtectedWrapper({ children }: RoleProtectedWrapperProps) {
    const { profile, loading } = useAuth();

    const hasFinancialAccess = Boolean(profile?.can_view_financials);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: 'var(--spacing-3xl)' }}>
                <div className="spinner" style={{ width: 32, height: 32, border: '3px solid var(--border-color)', borderTopColor: 'var(--color-primary)', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
            </div>
        );
    }

    if (hasFinancialAccess) {
        return <>{children}</>;
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: 'var(--spacing-3xl)',
            background: 'var(--bg-secondary)',
            borderRadius: 'var(--border-radius-lg)',
            border: '1px solid var(--border-color)',
            margin: 'var(--spacing-xl)'
        }}>
            <div style={{
                background: 'var(--bg-tertiary)',
                padding: 'var(--spacing-md)',
                borderRadius: '50%',
                marginBottom: 'var(--spacing-lg)'
            }}>
                <Lock size={32} color="var(--color-primary)" />
            </div>

            <h2 style={{ margin: '0 0 var(--spacing-sm)', color: 'var(--text-primary)' }}>Restricted Access</h2>
            <p style={{ color: 'var(--text-muted)', marginBottom: 'var(--spacing-xl)', textAlign: 'center', maxWidth: 400 }}>
                This section contains sensitive financial project data. You do not currently have the required permissions to view this information.
            </p>
            <p style={{ color: 'var(--text-muted)', fontSize: 'var(--font-size-sm)', textAlign: 'center', maxWidth: 400 }}>
                Please contact your administrator if you believe you should have access to the P&amp;L dashboard.
            </p>
        </div>
    );
}
